import React from 'react';

const Fintech = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2010_366)">
        <path
          d="M24.0195 8C24.0195 9.654 22.6735 11 21.0195 11V12H19.0195V11C17.3655 11 16.0195 9.654 16.0195 8H18.0195C18.0195 8.552 18.4675 9 19.0195 9H21.0195C21.5715 9 22.0195 8.552 22.0195 8C22.0195 7.621 21.7485 7.302 21.3745 7.239L18.3345 6.733C16.9925 6.509 16.0195 5.359 16.0195 4C16.0195 2.346 17.3655 1 19.0195 1V0H21.0195V1C22.6735 1 24.0195 2.346 24.0195 4H22.0195C22.0195 3.448 21.5715 3 21.0195 3H19.0195C18.4675 3 18.0195 3.448 18.0195 4C18.0195 4.379 18.2905 4.698 18.6645 4.761L21.7045 5.267C23.0465 5.491 24.0195 6.641 24.0195 8ZM17.0195 14H24.0195V20H13.0195V22H18.0195V24H6.01953V22H11.0195V20H0.0195312V5C0.0195312 3.346 1.36553 2 3.01953 2H14.4435C14.1745 2.614 14.0195 3.288 14.0195 4V8C14.0195 10.045 15.2565 11.802 17.0195 12.576V14ZM5.01953 11H3.01953V16H5.01953V11ZM9.01953 7H7.01953V16H9.01953V7ZM13.0195 10H11.0195V16H13.0195V10Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2010_366">
          <rect width="24" height="24" fill="white" transform="translate(0.0195312)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Fintech;
